<template>
  <div id="history-list">
    <hr />

    <div class="btn btn-warning float-right" @click="$emit('clearHistory')">
      Clear History
    </div>

    <h3>History</h3>
    (This is only visible to you on your browser)
    <!-- eslint-disable-next-line -->
    <div v-for="historyItem in uploadHistory.historyItems" class="row row-history-item">
      <b-col>
        <div class="header">
          <b-row>
            <b-col cols="6">
              <strong>{{ historyItem.meta_data.filename }}</strong>
            </b-col>
            <b-col cols="6" class="text-right">
              {{ historyItem.meta_data.timestamp }}
            </b-col>
          </b-row>
        </div>
        <div class="message">Response: {{ historyItem.meta_data.message }}</div>
        <div class="error-list">
          <div v-for="(rowErrors, rowIndex) in historyItem.errors" :key="rowIndex">
            Row {{ rowIndex }}:
            <ul>
              <li v-for="(error, errorIndex) in rowErrors" :key="errorIndex">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </div>
      </b-col>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfferUploadHistory',
  props: ['uploadHistory'],
};
</script>

<style lang="scss" scoped>
h3 {
  margin-bottom: 0;
}

#history-list {
  .header {
    background-color: darken(#e9ecef, 10%);
    padding: 5px;
  }
  .row-history-item {
    margin-bottom: 10px;
  }
  .message {
    padding: 5px;
    background-color: darken(#e9ecef, 6%);
  }
  .error-list {
    padding-left: 15px;
    list-style-type: none;
    background-color: darken(#e9ecef, 3%);
    li {
      border-bottom: 1px solid darken(#e9ecef, 8%);
    }
  }
}
</style>
